import { BaseRouteService } from 'core/services';

class BillingRouteService extends BaseRouteService {
	constructor() {
		super();
		this.lojisticBase = 'lojistic/';
		this.quickBooksBase = 'quickbooks/';
	}

	importCharges(fromDate, toDate) {
		return this.uriTemplateService
			.parse(`${this.lojisticBase}charge-detail/import{?fromDate,toDate}`)
			.expand({ fromDate, toDate });
	}

	calculateUpcharges() {
		return `${this.lojisticBase}invoice-detail/calculate-upcharges`;
	}

	findMatches() {
		return `${this.lojisticBase}invoice-detail/matches`;
	}

	assign() {
		return `${this.lojisticBase}invoice-detail/assign`;
	}

	unassign(trackingNumber, carrier) {
		return this.uriTemplateService
			.parse(`${this.lojisticBase}invoice-detail/unassign{?trackingNumber,carrier}`)
			.expand({ trackingNumber, carrier });
	}

	// POST creates invoices; GET lists the ones already created.
	invoices() {
		return `${this.quickBooksBase}invoices`;
	}
}

export default BillingRouteService;
